.remove-button {
  flex-grow: 4;
  align-self: center;
  text-align: end;
  padding-right: 20px;
}
